var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H16.6667L18 16.6667M18 16.6667H70L56.6667 43.3333H23.3333M18 16.6667L23.3333 43.3333M23.3333 43.3333L15.69 50.9767C13.59 53.0767 15.0767 56.6667 18.0467 56.6667H56.6667M56.6667 56.6667C54.8986 56.6667 53.2029 57.369 51.9526 58.6193C50.7024 59.8695 50 61.5652 50 63.3333C50 65.1014 50.7024 66.7971 51.9526 68.0474C53.2029 69.2976 54.8986 70 56.6667 70C58.4348 70 60.1305 69.2976 61.3807 68.0474C62.631 66.7971 63.3333 65.1014 63.3333 63.3333C63.3333 61.5652 62.631 59.8695 61.3807 58.6193C60.1305 57.369 58.4348 56.6667 56.6667 56.6667ZM30 63.3333C30 65.1014 29.2976 66.7971 28.0474 68.0474C26.7971 69.2976 25.1014 70 23.3333 70C21.5652 70 19.8695 69.2976 18.6193 68.0474C17.369 66.7971 16.6667 65.1014 16.6667 63.3333C16.6667 61.5652 17.369 59.8695 18.6193 58.6193C19.8695 57.369 21.5652 56.6667 23.3333 56.6667C25.1014 56.6667 26.7971 57.369 28.0474 58.6193C29.2976 59.8695 30 61.5652 30 63.3333Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.f0337ad4689641e0f6c014c460a2fda3.svg";
export { ForwardRef as ReactComponent };